/**
 * Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022-2026)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { opacities } from "~lib/theme/primitives/opacities"

export const STALE_TRANSITION_PARAMS = "1s ease-in 0.5s"

export const STALE_STYLES = {
  opacity: opacities.stale,
  transition: `opacity ${STALE_TRANSITION_PARAMS}`,
}

/**
 * Removes an element from the visual layout while keeping it in the
 * accessibility tree, for text that only screen readers should reach.
 */
export const VISUALLY_HIDDEN_STYLES = {
  position: "absolute" as const,
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap" as const,
  border: 0,
}
